import { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography
} from "@mui/material";

const MAX_SESSION_DURATION = 6 * 60 * 60 * 1000; // 6 heures
const WARNING_BEFORE_EXPIRY = 5 * 60 * 1000;     // 5 minutes

const AutoLogoutHandler = () => {
  const [openWarning, setOpenWarning] = useState(false);
  const [openExpired, setOpenExpired] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    const checkSession = () => {
      const loginTime = localStorage.getItem("loginTime");

      if (loginTime) {
        const elapsed = Date.now() - parseInt(loginTime, 10);

        if (elapsed > MAX_SESSION_DURATION) {
          setOpenWarning(false);
          setOpenExpired(true);
        } else if (
          elapsed > MAX_SESSION_DURATION - WARNING_BEFORE_EXPIRY &&
          !openWarning
        ) {
          setOpenWarning(true);
        }
      }
    };

    const id = setInterval(checkSession, 60 * 1000); // vérifie toutes les minutes
    setIntervalId(id);
    checkSession(); // dès le chargement

    return () => clearInterval(id);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    if (intervalId) clearInterval(intervalId);
    window.location.href = "/login";
  };

  const handleStayConnected = () => {
    localStorage.setItem("loginTime", Date.now().toString()); // relance la session
    setOpenWarning(false);
  };

  return (
    <>
      {/* Modale d'avertissement */}
      <Dialog open={openWarning} onClose={handleStayConnected}>
        <DialogTitle>⏳ Session bientôt expirée</DialogTitle>
        <DialogContent>
          <Typography>
            Votre session va expirer dans moins de 5 minutes.
          </Typography>
          <Typography mt={1}>
            Voulez-vous rester connecté ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogout} color="error">Se déconnecter</Button>
          <Button onClick={handleStayConnected} variant="contained" color="primary">
            Rester connecté
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modale d'expiration */}
      <Dialog open={openExpired} onClose={handleLogout}>
        <DialogTitle>🔒 Session expirée</DialogTitle>
        <DialogContent>
          <Typography>
            Pour des raisons de sécurité, votre session a expiré.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogout} variant="contained" color="primary">
            Se reconnecter
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AutoLogoutHandler;
